import * as _ from 'lodash';

import Uuid from '../../../../support/Uuid';
import DecimalAmount from '../../../../support/DecimalAmount';

class FactorajeFinancieroPagoCalculator {
  data = {};

  constructor(data) {
    this.data = _.cloneDeep(data);
  }

  static make(data) {
    return new FactorajeFinancieroPagoCalculator(data);
  }

  apply(response = {}) {
    let Pagos = {};

    const { data } = this.data;
    const { Factoraje } = data;

    if (Factoraje.Pagos === 0) {
      Pagos = this.getPrevPagos(data);
    } else if (Factoraje.NumeroParcialidad === 3) {
      Pagos = this.getNextPagos(data);
    } else {
      Pagos = this.getDefaultNextPagos(data);
    }

    return Pagos;
  }

  getPrevPagos = (data) => {
    const { ImportePagoInicial, CompensacionHonorarios, Equivalencia, Moneda } = data.FactorajeFinanciero;

    const saldoAnterior = data.Total;

    const Pago = DecimalAmount.make(ImportePagoInicial / (Equivalencia || 1)).toFixed(2);
    const Compensacion = DecimalAmount.make(CompensacionHonorarios / (Equivalencia || 1)).toFixed(2);

    if (Moneda === 'MXN') {
      data.TipoCambio = '1';
    }

    return [
      {
        id: Uuid.v4(),
        FechaPago: new Date(),
        HoraPago: '12:00',
        FormaDePagoP: '03',
        Monto: ImportePagoInicial,
        MonedaP: Moneda !== data.Moneda ? Moneda : data.Moneda,
        TipoCambioP: data.TipoCambio,
        IdDocumento: data.uuid,
        MonedaDR: data.Moneda,
        EquivalenciaDR: Equivalencia,
        NumParcialidad: 1,
        ImpSaldoAnt: saldoAnterior,
        ImpPagado: Pago,
        ImpSaldoInsoluto: this.getSaldoInsoluto(saldoAnterior, Pago),
        ObjetoImpDR: '01',
        ImpuestosDR: [],
      },
      {
        id: Uuid.v4(),
        FechaPago: new Date(),
        HoraPago: '12:00',
        FormaDePagoP: '17',
        Monto: CompensacionHonorarios,
        MonedaP: Moneda !== data.Moneda ? Moneda : data.Moneda,
        TipoCambioP: data.TipoCambio,
        IdDocumento: data.uuid,
        MonedaDR: data.Moneda,
        EquivalenciaDR: Equivalencia,
        NumParcialidad: 2,
        ImpSaldoAnt: this.getSaldoInsoluto(saldoAnterior, Pago),
        ImpPagado: Compensacion,
        ImpSaldoInsoluto: this.getSaldoInsoluto(this.getSaldoInsoluto(saldoAnterior, Pago), Compensacion),
        ObjetoImpDR: '01',
        ImpuestosDR: [],
      },
    ];
  };

  getNextPagos = (data) => {
    const { ImportePagoFinal, CompensacionIntereses, Equivalencia, Moneda } = data.FactorajeFinanciero;

    let saldoAnterior = data.Factoraje.ImporteSaldoInsoluto;

    let PagoDR = DecimalAmount.make(ImportePagoFinal / (Equivalencia || 1)).toFixed(2);
    const CompensacionDR = DecimalAmount.make(CompensacionIntereses / (Equivalencia || 1)).toFixed(2);

    if (Moneda === 'MXN') {
      data.TipoCambio = '1';
    }

    return [
      {
        id: Uuid.v4(),
        FechaPago: new Date(),
        HoraPago: '12:00',
        FormaDePagoP: '03',
        Monto: ImportePagoFinal,
        MonedaP: Moneda !== data.Moneda ? Moneda : data.Moneda,
        TipoCambioP: data.TipoCambio,
        EquivalenciaDR: Equivalencia,
        IdDocumento: data.uuid,
        MonedaDR: data.Moneda,
        NumParcialidad: 3,
        ImpSaldoAnt: saldoAnterior,
        ImpPagado: PagoDR,
        ImpSaldoInsoluto: this.getSaldoInsoluto(saldoAnterior, PagoDR),
        ObjetoImpDR: '01',
        ImpuestosDR: [],
      },
      {
        id: Uuid.v4(),
        FechaPago: new Date(),
        HoraPago: '12:00',
        FormaDePagoP: '17',
        Monto: CompensacionIntereses,
        MonedaP: Moneda !== data.Moneda ? Moneda : data.Moneda,
        TipoCambioP: data.TipoCambio,
        EquivalenciaDR: Equivalencia,
        IdDocumento: data.uuid,
        MonedaDR: data.Moneda,
        NumParcialidad: 4,
        ImpSaldoAnt: this.getSaldoInsoluto(saldoAnterior, PagoDR),
        ImpPagado: CompensacionDR,
        ImpSaldoInsoluto: this.getSaldoInsoluto(this.getSaldoInsoluto(saldoAnterior, PagoDR), CompensacionDR),
        ObjetoImpDR: '01',
        ImpuestosDR: [],
      },
    ];
  };

  getDefaultNextPagos = (data) => {
    const { Equivalencia, Moneda } = data.FactorajeFinanciero;

    let saldoAnterior = data.Factoraje.ImporteSaldoInsoluto;

    let PagoDR = DecimalAmount.make(saldoAnterior / (Equivalencia || 1)).toFixed(2);

    const { Factoraje } = data;

    if (Moneda === 'MXN') {
      data.TipoCambio = '1';
    }

    return [
      {
        id: Uuid.v4(),
        FechaPago: new Date(),
        HoraPago: '12:00',
        FormaDePagoP: '03',
        Monto: saldoAnterior,
        MonedaP: Moneda !== data.Moneda ? Moneda : data.Moneda,
        TipoCambioP: data.TipoCambio,
        EquivalenciaDR: Equivalencia,
        IdDocumento: data.uuid,
        MonedaDR: data.Moneda,
        NumParcialidad: Factoraje.NumeroParcialidad,
        ImpSaldoAnt: saldoAnterior,
        ImpPagado: PagoDR,
        ImpSaldoInsoluto: this.getSaldoInsoluto(saldoAnterior, PagoDR),
        ObjetoImpDR: '01',
        ImpuestosDR: [],
      },
    ];
  };

  getSaldoInsoluto = (saldoAnterior, Monto) => {
    return DecimalAmount.make(parseFloat(saldoAnterior) - parseFloat(Monto)).toFixed(2);
  };
}

export default FactorajeFinancieroPagoCalculator;
